import React, { useState, useEffect } from "react";
import { Breadcrumb, Image, Table } from "antd";
import Loader from "../../components/loader/loader";
import { addIcon, editIcon, homeIcon, redTrash } from "../../assets";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";
import { useNavigate } from "react-router-dom";
import { GreenNotify } from "../../helper/helper";
import moment from "moment";
import DeleteModal from "../../components/deleteModal/DeleteModal";

const LocalityCard = () => {
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [loyaltyCards, setLoyaltyCards] = useState([]);
  const [getServiceapi, setGetServiceApi] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const getAllEmployerCards = () => {
    let getRes = (res) => {
      //   console.log("res of getAllEmployers", res);
      setLoyaltyCards(res?.data?.data);
    };

    callApi(
      "GET",
      routes.getLoyaltyCards,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
      }
    );
  };

  const handleDeleteClick = (card) => {
    setSelectedCard(card);
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedCard?._id) {
      deleteEmployer(selectedCard._id);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteModalVisible(false);
    setSelectedCard(null);
  };

  const deleteEmployer = (id) => {
    setGetServiceApi(false);
    let getRes = (res) => {
      console.log("res of delete Loyal card", res);
      GreenNotify("Loyalty card is deleted successfully");
      setGetServiceApi(true);
      setDeleteModalVisible(false);
      setSelectedCard(null);
    };

    callApi(
      "DELETE",
      `${routes.getLoyaltyCards}/${id}`,
      null,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        setDeleteModalVisible(false);
        setSelectedCard(null);
      }
    );
  };

  useEffect(() => {
    getAllEmployerCards();
  }, [getServiceapi]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Date",
      dataIndex: "date",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Card Number",
      dataIndex: "number",
      className: "role-name-column-header",
      align: "center",
    },
    // {
    //   title: "Creator",
    //   dataIndex: "creator",
    //   className: "role-name-column-header",
    //   align: "center",
    // },

    {
      title: "Front image",
      dataIndex: "front",
      className: "role-name-column-header",
      align: "center",
    },
    {
      title: "Back Image",
      dataIndex: "back",
      className: "role-name-column-header",
      align: "center",
    },

    {
      title: "Delete",
      dataIndex: "delete",
      align: "center",
      className: "action-column-header",
    },
  ];

  const data = loyaltyCards?.map((item, index) => {
    return {
      key: index,
      name: item?.loyaltyName,
      quote: item?.quote,
      number: item?.cardNumber,
      // creator: item?.creator?.name,
      date: moment(item?.createdAt).format("DD-MM-YYYY"),
      front: (
        <div className="product-list-image">
          <Image width={50} src={item?.frontImage} alt="loyalty-card" />
        </div>
      ),
      back: (
        <div className="product-list-image">
          <Image width={50} src={item?.backImage} alt="loyalty-card" />
        </div>
      ),
      delete: (
        <div
          onClick={() => handleDeleteClick(item)}
          className="action-icon-btn delete-btn"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6H5H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 11V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Delete</span>
        </div>
      ),
    };
  });

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };

  return (
    <div className="modern-page-container">
      <Loader loading={isloading} />
      <DeleteModal
        visible={deleteModalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        title="Delete Loyalty Card"
        message="Are you sure you want to delete loyalty card"
        itemName={selectedCard?.loyaltyName}
        isLoading={isloading}
      />
      
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <Breadcrumb
              separator="›"
              className="modern-breadcrumb"
              items={[
                { title: "Dashboard" },
                {
                  title: (
                    <span className="breadcrumb-active">Loyalty Cards</span>
                  ),
                },
              ]}
            />
            <h1 className="page-title">Loyalty Cards Management</h1>
            <p className="page-subtitle">Manage and view all loyalty cards</p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="4" width="20" height="16" rx="2" stroke="white" strokeWidth="2"/>
              <path d="M2 10H22" stroke="white" strokeWidth="2"/>
              <path d="M6 15H10" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Total Cards</p>
            <h3 className="stat-value">{loyaltyCards?.length || 0}</h3>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M22 4L12 14.01L9 11.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Active Cards</p>
            <h3 className="stat-value">{loyaltyCards?.length || 0}</h3>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 1.17157 16.1716C0.421427 16.9217 0 17.9391 0 19V21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="stat-info">
            <p className="stat-label">Card Holders</p>
            <h3 className="stat-value">{loyaltyCards?.length || 0}</h3>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="content-card">
        <div className="card-header">
          <h2 className="card-title">All Loyalty Cards</h2>
        </div>

        <div className="table-container">
          <Table
            rowClassName={getRowClassName}
            columns={columns}
            dataSource={data}
            pagination={{
              pageSize: 5,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} cards`,
            }}
            scroll={{ x: 1000 }}
          />
        </div>
      </div>
    </div>
  );
};

export default LocalityCard;
